import { PROFILE_ENVIRONMENT, PROFILE_ID } from "./enums";

export default {
  chatbotId: PROFILE_ID.SKY_PE_CHATBOT_ES,
  credentials: [
    {
      environment: PROFILE_ENVIRONMENT.DEVELOPMENT,
      inbentaKey: "BeMVcwJqRRVmHqY5yc5YjnGRrcUFdVsJ0/yLDOyB+Ic=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X3BlX2NoYXRib3RfZXMiLCJkb21haW5fa2V5X2lkIjoiQmhVMGUzSURiRTR3M1U0OFY4RW53dzo6In0.XWVdst6PQXtr4GOxriOrLOAARcRAQn5_C7hUns7F0ErZmKSwD9-z6ppDblDCwSrO-tWej8WVdLIsXG5FK-7QGw",
    },
    {
      environment: PROFILE_ENVIRONMENT.PRODUCTION,
      userType: 0,
      inbentaKey: "BeMVcwJPzoid8PRiRA+ltg6BVF2VtH/ogBZhmElwA2Q=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X3BlX2NoYXRib3RfZXMiLCJkb21haW5fa2V5X2lkIjoiQmhocUV4cll1OHAyRUFnbGtLN2tGZzo6In0.jR_ELVpGzVbTcgucRWyIrwaZF27uMxaGtjw7p25tS--2uEO0r1iqONGZ-c-7Qvp0hq-dA7QwP07ObfiIbJsd4Q",
    },
  ],
};
